module.exports = __webpack_public_path__ + "media/images/icon__point--gained@3x-32fae5c6b443046da114e31aa8216db8.png";